export default __webpack_public_path__ + "static/media/crescent_pike.9e473ddb.png";